// export { default } from './LoginLayout';

import LoginLayout from "./LoginLayout";

export default LoginLayout